import { Phone, MessageCircle } from 'lucide-react';
import { Card, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { siteInfo } from '../../data/mock';

export const ContactMethods = ({ handleWhatsAppClick, handleCallClick }) => (
<div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <Card data-testid="contact-whatsapp-card" className="contact-method bg-gradient-to-br from-green-900/40 to-green-950/40 border-2 border-green-600/50">
                <CardContent className="pt-8">
                  <div className="flex flex-col sm:flex-row items-start gap-4 mb-6">
                    <div className="bg-gradient-to-br from-green-500 to-green-700 p-4 rounded-xl">
                      <MessageCircle className="w-8 h-8 text-white" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-green-400 mb-3">WhatsApp - Contact Prioritaire</h3>
                      <p data-testid="contact-whatsapp-number" className="text-white font-semibold text-xl mb-2">{siteInfo.phoneDisplay}</p>
                      <p className="text-gray-300 mb-4">Réponse en moins de 5 minutes • Disponible 7j/7</p>
                      <Button 
                        data-testid="contact-whatsapp-button"
                        onClick={handleWhatsAppClick}
                        className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white text-base md:text-lg py-5 md:py-6 font-bold shadow-xl shadow-green-500/40 flex items-center justify-center"
                      >
                        <MessageCircle className="w-5 h-5 mr-2 flex-shrink-0" />
                        <span>WhatsApp</span>
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>

              <Card data-testid="contact-phone-card" className="contact-method bg-gradient-to-br from-red-900/40 to-red-950/40 border-2 border-red-600/50">
                <CardContent className="pt-8">
                  <div className="flex flex-col sm:flex-row items-start gap-4 mb-6">
                    <div className="bg-gradient-to-br from-red-600 to-red-800 p-4 rounded-xl">
                      <Phone className="w-8 h-8 text-white" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-2xl font-bold text-red-400 mb-3">Téléphone - Appel Direct</h3>
                      <p data-testid="contact-phone-number" className="text-white font-semibold text-xl mb-2">{siteInfo.phoneDisplay}</p>
                      <p className="text-gray-300 mb-4">Consultation téléphonique immédiate</p>
                      <Button 
                        data-testid="contact-call-button"
                        onClick={handleCallClick}
                        className="w-full h-auto whitespace-normal bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white text-base md:text-lg py-4 font-bold shadow-xl shadow-red-600/40"
                      >
                        <Phone className="w-5 h-5 mr-2 flex-shrink-0" />
                        Appeler Maître Diamma
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
);
